import React from 'react';
import NavMenu from '../Nav/NavMenu';
import Footer from '../footer/Footer';
import EmptySlider from '../sliders/EmptySlider';
import FlightImage from "../../assets/static/support.png";
import { Container, Row, Col, Button } from 'react-bootstrap';
import groupAccountImage from "../../assets/static/business/njangi_members.png"; 

function GroupAccount() {
  return (
    <div>
      <NavMenu></NavMenu>
      <br></br><br></br>
      <EmptySlider 
        title="Group Account? We’ve got you covered." 
        description="Kontriman offers various ways to support your Group Account – through our help center, chat support, and email. Get the assistance you need, anytime and anywhere." 
        imageUrl={FlightImage}
    />
     <div>
      <Container fluid className="my-5 bg-custom">
        <Container className='container-padding'>
          <Row className="flex-column flex-md-row">
            {/* Image column */}
            <Col md={6} className="order-2 order-md-1">
              <img
                src={groupAccountImage}
                alt="Group Accounts"
                className="img-fluid"
              />
            </Col>

            {/* Text column */}
            <Col md={6} className="d-flex align-items-center order-1 order-md-2">
              <div>
                <h1 className='custom_heading'>Group Accounts with Kontriman</h1>
                <p>
                  Designed for cooperatives, clubs, and community groups, Kontriman’s Group Accounts provide an efficient way to manage shared funds securely.
                </p>
                <p>
                  Enjoy transparent transactions, multiple signatories for added security, and easy access to funds for group activities. Our solution supports financial collaboration and accountability within your group.
                </p>
                <p><strong>Key Features:</strong></p>
                <ul>
                  <li>Multiple authorized signatories</li>
                  <li>Transparent and secure fund management</li>
                  <li>Easy deposits and withdrawals for group activities</li>
                  <li>Access to digital banking tools</li>
                  <li>Dedicated customer support for groups</li>
                </ul>

                <a href="login">
                  <Button className='custom-button mt-3'>Open a Group Account</Button>
                </a>
              </div>
            </Col>
          </Row>
        </Container>
      </Container>
    </div>

      <Footer></Footer>
    </div>
  );
}

export default GroupAccount;
